import { render, staticRenderFns } from "./RightIndex.vue?vue&type=template&id=abf0225c&"
import script from "./RightIndex.vue?vue&type=script&lang=js&"
export * from "./RightIndex.vue?vue&type=script&lang=js&"
import style0 from "./RightIndex.vue?vue&type=style&index=0&id=abf0225c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports